export default __webpack_public_path__ + "static/img_case_02-77610f946b686d9deb362ae71e5202da.webp";